import { Button, Popconfirm } from "antd";

type TAZPopConfirm = {
  placement   : any,
  confirmText : string,
  buttonText  : string,
  danger?     : boolean,
  onConfirm   : () => void,
}

const AZPopConfirm = ({
  placement,
  confirmText,
  buttonText,
  danger = true,
  onConfirm,
}: TAZPopConfirm) => {
  return (
    <Popconfirm
      placement={placement}
      title={confirmText}
      onConfirm={onConfirm}
      okText="Yes"
      cancelText="No"
    >
      <Button type="primary" danger={danger}>{buttonText}</Button>
    </Popconfirm>
  )
};

export default AZPopConfirm;